import { OrderDTO, OrderHoldDTO, OrderLineDTO } from '@invenco/sales-interface/interfaces';

import { OrderHoldItem } from './OrderHoldItem';
import { List } from './styles';

type Props = {
  holds: OrderHoldDTO[];
  orderDetails: Partial<OrderDTO>;
  orderLines: Partial<OrderLineDTO>[];
};

export function OrderHolds({ orderDetails, orderLines, holds }: Props) {
  return (
    <List>
      {holds.map((hold) => (
        <OrderHoldItem
          key={hold.id}
          orderDetails={orderDetails}
          orderLines={orderLines}
          hold={hold}
        />
      ))}
    </List>
  );
}
